const skills = {
  languages: ["Python", "C++", "Java", "JavaScript", "TypeScript", "HTML/CSS", "SQL"],
  frameworks: ["React", "Next.js", "Flask"],
  data: ["Tableau", "scikit-learn"],
  creative: ["Blender", "Processing", "Sony Vegas Pro", "Adobe After Effects"]
};

export default skills;
